import {default as CategoryFilter} from './CategoryFilter'

document.querySelectorAll('[data-app="category-filter"]').forEach((element) => {
  const url = element.getAttribute('data-url')
  fetch(url)
    .then(function(response) {
      return response.json();
    })
    .then(function(json) {
      new CategoryFilter(element, json)
    })
})
